<template>
  <v-app class="" id="app">
    <Misc_PopupWindow v-if="popup_open" @close-modal="popup_open = false" />
    <TooltipModal v-if="tt_open" @close-modal="tt_open = false" :tooltip_data="this.tooltip_data" />
    <v-layout>
      <NavBar></NavBar>
      <div class="wrapper-content">
          <router-view v-slot="{ Component, route }" style="width:100%;margin-top:64px;padding:0px;left:0;right:0;">
            <component :is="Component" :key="route.fullPath" @toggle-websocket="this.onToggleWebsocket"
              :websocket="this.websocket"
              @close-tooltip="tt_open = false;" />
          </router-view>
      </div>
    </v-layout>
    <Footer lazy></Footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/navbars/NavBar"
import Footer from "@/components/navbars/Footer"
import { h, ref } from 'vue'
import { useDisplay } from 'vuetify'
import Misc_PopupWindow from "@/components/misc_components/Misc_PopupWindow.vue";
import ws from "@/methods/websocket";
import dd from "@/methods/data_description";
import TooltipModal from "./components/tooltip/TooltipModal.vue";

export default {
  name: 'App',
  components: {
    NavBar,
    Footer,
    Misc_PopupWindow,
    TooltipModal,
  },
  setup() {
    const { name } = useDisplay()
    const popup_open = ref(false);
    const tt_open = ref(false);
    const tooltip_data = ref({
      title: 'Tooltip-Test',
      desc: 'This is a random tooltip. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, \
       sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, \
       sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. \
       Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. \
       Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, \
       sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, \
       no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      link: 'https://www.example.com'
    });

    return {
      popup_open,
      tt_open,
      tooltip_data,
    }
  },
  computed: {
    imageHeight() {
      switch (this.display) {
        case 'xs': return '220px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return '800px'
    },
  },
  data: () => ({
    isMobile: false,
    msg: process.env.VUE_APP_ONKOPUS_SERVER,
    server_path: process.env.VUE_APP_ONKOPUS_SERVER,
    module_server: process.env.VUE_APP_ONKOPUS_MODULE_SERVER,
    module_server_protocol: process.env.VUE_APP_ONKOPUS_SERVER_PROTOCOL,
    module_server_port: process.env.VUE_APP_ONKOPUS_SERVER_PORT,
    module_am_port: process.env.VUE_APP_ONKOPUS_AM_PORT,
    methods_get_ids: process.env.VUE_APP_METHODS_GET_IDS,
    methods_get_mtb_conferences: process.env.VUE_APP_METHODS_GET_MTB_CONFERENCES,
    methods_get_mtb_data: process.env.VUE_APP_METHODS_GET_MTB_PATIENTS,
    methods_get_id_feature_data: process.env.VUE_APP_METHODS_GET_ID_FEATURE_DATA,
    methods_get_id_variant_data: process.env.VUE_APP_METHODS_GET_ID_VARIANT_DATA,
    methods_upload_vcf: process.env.VUE_APP_METHODS_UPLOAD_VCF,
    methods_get_variant_search: process.env.VUE_APP_METHODS_GET_VARIANT_SEARCH,
    methods_analyze_variants: process.env.VUE_APP_METHODS_ANALYZE_VARIANTS,
    methods_get_annotated_modules: process.env.VUE_APP_METHODS_GET_ANNOTATED_MODULES,
    methods_get_sample_vcf_data: process.env.VUE_APP_METHODS_GET_SAMPLE_VCF_DATA,
    methods_generate_new_id: process.env.VUE_APP_METHODS_GENERATE_NEW_ID,
    methods_generate_plot: process.env.VUE_APP_METHODS_GENERATE_PLOT,
    methods_download_results: process.env.VUE_APP_METHODS_DOWNLOAD_RESULTS,
    methods_get_sample_file: process.env.VUE_APP_METHODS_GET_SAMPLE_FILE,
    methods_get_am_region_scores: process.env.VUE_APP_METHODS_AM_REGIONS,
    methods_get_os_swagger_endpoint: process.env.VUE_APP_OS_SWAGGER_ENDPOINT,
    active_modules: process.env.VUE_APP_ACTIVE_MODULES,
    router_base_url: '/' + process.env.VUE_APP_ROUTER_BASE_URL,
    websocket_ip: process.env.VUE_APP_PRESENTATION_WS_SERVER_IP,
    websocket_port: process.env.VUE_APP_PRESENTATION_WS_SERVER_PORT,
    devmode_flag: process.env.VUE_APP_ONKOPUS_INTERNAL,
    collapsed: "",
    nav_bar_logo: require('@/assets/onkopus_logo_v0.1.png'),

    drawer: false,
    group: null,
    websocket: null,
    websocket_id: '',
  }),

  beforeUnmount() {
    if (typeof window === 'undefined') return

    //window.removeEventListener('resize', this.onResize, { passive: true })
    //window.removeEventListener('show-tooltip', (e) => this.toggleTooltip(e));
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    async startRequestVariantListSearchBar() {
      this.$router.push({ path: this.$store.getters.getRouterBaseURL + '/upload/show-variant-interpretation-results-q', query: { q: this.variantlisttextappbar } })
    },
    render() {
      return h('div')
    },
    /**
     * This method can be used to toggle an arbitrary tooltip to show up/close anywhere on the screen.
     * All that has to be provided is *either* a left or a right coordinate and a top coordinate for the tooltip window.
     * Further you can provide a tooltip link, desc and title (see TooltipModal.vue).
     * @param {Object} event_data - Data of the tooltip event that was fired
     */
    toggleTooltip(event_data) {
      
      // Delete left/right coord data and current data (except title and tooltip ID)
      delete this.tooltip_data.left;
      delete this.tooltip_data.right;
      delete this.tooltip_data.score;
      delete this.tooltip_data.desc;
      delete this.tooltip_data.link;

      // Toggle off tooltip if its currently open
      if (this.tt_open && (this.tooltip_data.title == event_data.detail.title || this.tooltip_data.tooltip_id == event_data.detail.tooltip_id)) {
        this.tt_open = false;
        return;
      }
      // Open tooltip if its not currently open
      else {
        this.tt_open = true;
        this.tooltip_data.left = event_data.detail.left;
        this.tooltip_data.top = event_data.detail.top;
        this.tooltip_data.title = event_data.detail.title;
        this.tooltip_data.right = event_data.detail.right;
        this.tooltip_data.tooltip_id = event_data.detail.tooltip_id;

        var info_from_file = dd.get(event_data.detail.tooltip_id ? event_data.detail.tooltip_id : event_data.detail.title);
        if (info_from_file.score) this.tooltip_data.score = info_from_file.score;
        if (info_from_file.link) this.tooltip_data.link = info_from_file.link;
        if (info_from_file.desc) this.tooltip_data.desc = info_from_file.desc;
        if (info_from_file.title) this.tooltip_data.title = info_from_file.title;
      }
    },
    /**
     * A websocket toggle event can be passed up from any component in the router view.
     * For that, the emit @toggle-websocket has to be passed up from the included view.
     * This will toggle the websocket on or off.
     * The store only keeps the current ID of the socket.
     * @param {Object} emit_params - Additional parameters from wherever the socket was toggled on/off.
     */
    async onToggleWebsocket(emit_params) {

      // Close websocket if it is toggled off using the icon
      if (this.websocket != null) {
        this.websocket.close();
        this.websocket = null;
        this.$store.dispatch('setPresentationID', '');
      }
      // Otherwise, open a new web socket
      else {
        try {
          // Ask for device name (uses localstorage) or generate a random one
          if (localStorage.getItem("onkopus_device_name") === null) {
            let onkopus_device_name = window.prompt("Please name your device!");
            if (onkopus_device_name === null) {
              let ws_id = Date.now().toString();
              ws_id = ws_id.substring(Math.min(0, ws_id.length - 6), ws_id.length);
              onkopus_device_name = ws_id;
            }
            localStorage.setItem("onkopus_device_name", onkopus_device_name);
          }
          this.websocket_id = localStorage.getItem("onkopus_device_name");
        }
        catch {
          // If this fails (e.g. localStorage isnt available) we again choose a random ID
          let ws_id = Date.now().toString();
          ws_id = ws_id.substring(Math.min(0, ws_id.length - 6), ws_id.length);
          this.websocket_id = ws_id;
        }
        this.$store.dispatch('setPresentationID', this.websocket_id);

        let ws_ip = this.$store.getters.getEnvVariable('presentation_websocket_ip');
        let ws_port = this.$store.getters.getEnvVariable('presentation_websocket_port');
        let ws_url = `ws://${(ws_ip ? ws_ip : 'mtbvm')}:${(ws_port ? ws_port : 8181)}`;
        this.websocket = new WebSocket(ws_url);

        try {

          // Add event listeners to the web socket
          this.websocket.addEventListener("open", () => {

            // Send server a connection notification
            console.log("Sending connection info")
            this.websocket.send(JSON.stringify({ codeword: "connect", id: this.websocket_id.toString(), showing: emit_params.showing }));

            // Add message handler
            this.websocket.addEventListener("message", (msg) => ws.handleAllMessages(this.websocket, msg));

            // Query initial stuff
            this.websocket.send(JSON.stringify({ codeword: 'give-current-patient-id' }));

            // Add close handler
            this.websocket.addEventListener("close", () => {
              console.log(`Closed web socket with ID ${this.websocket_id ? this.websocket_id : 'unknown'}`);
              //onclose stuff, prob. send a message to server
            })
          })
        }
        catch (error) {
          console.error("Error occurred during creation of web socket.");
          console.log(error);
        }
      }
    },
  },
  created: function () {
    this.mobile = useDisplay()
    window.addEventListener('show-tooltip', (e) => this.toggleTooltip(e));

    // set default Vuex Store variables
    if (this.router_base_url == '/') {
      this.$store.dispatch('setRouterBaseUrl', '')
    } else {
      this.$store.dispatch('setRouterBaseUrl', this.router_base_url)
    }

    this.$store.dispatch('setEnvVariable', ["module_server", this.module_server])
    this.$store.dispatch('setEnvVariable', ["server_path", this.server_path])
    this.$store.dispatch('setEnvVariable', ["module_server_protocol", this.module_server_protocol])
    this.$store.dispatch('setEnvVariable', ["module_server_port", this.module_server_port])
    this.$store.dispatch('setEnvVariable', ["module_am_port", this.module_am_port])
    this.$store.dispatch('setEnvVariable', ["methods_get_ids", this.methods_get_ids])
    this.$store.dispatch('setEnvVariable', ["methods_get_mtb_conferences", this.methods_get_mtb_conferences])
    this.$store.dispatch('setEnvVariable', ["methods_get_mtb_data", this.methods_get_mtb_data])
    this.$store.dispatch('setEnvVariable', ["methods_get_id_feature_data", this.methods_get_id_feature_data])
    this.$store.dispatch('setEnvVariable', ["methods_get_id_variant_data", this.methods_get_id_variant_data])
    this.$store.dispatch('setEnvVariable', ["methods_upload_vcf", this.methods_upload_vcf])
    this.$store.dispatch('setEnvVariable', ["methods_get_variant_search", this.methods_get_variant_search])
    this.$store.dispatch('setEnvVariable', ["methods_analyze_variants", this.methods_analyze_variants])
    this.$store.dispatch('setEnvVariable', ["methods_get_annotated_modules", this.methods_get_annotated_modules])
    this.$store.dispatch('setEnvVariable', ["methods_generate_new_id", this.methods_generate_new_id])
    this.$store.dispatch('setEnvVariable', ["methods_generate_plot", this.methods_generate_plot])
    this.$store.dispatch('setEnvVariable', ["presentation_websocket_ip", this.websocket_ip]);
    this.$store.dispatch('setEnvVariable', ["presentation_websocket_port", this.websocket_port]);
    this.$store.dispatch('setEnvVariable', ["methods_download_results", this.methods_download_results])
    this.$store.dispatch('setEnvVariable', ["methods_get_sample_file", this.methods_get_sample_file])
    this.$store.dispatch('setEnvVariable', ["methods_get_am_region_scores", this.methods_get_am_region_scores])
    this.$store.dispatch('setEnvVariable', ["methods_get_os_swagger_endpoint", this.methods_get_os_swagger_endpoint])

    this.$store.dispatch('setProcessState', ["load-genompos", ""])
    this.$store.dispatch('setProcessState', ["load-gene-name", ""])
    this.$store.dispatch('setProcessState', ["load-variant-exchange", ""])
    this.$store.dispatch('setProcessState', ["load-dbsnp", ""])
    this.$store.dispatch('setProcessState', ["load-clinvar", ""])
    this.$store.dispatch('setProcessState', ["load-revel", ""])
    this.$store.dispatch('setProcessState', ["load-loftool", ""])
    this.$store.dispatch('setProcessState', ["load-vusp", ""])
    this.$store.dispatch('setProcessState', ["load-interpretations", ""])

    this.$store.dispatch('setDevmodeFlag', this.devmode_flag);

    let active_modules_list = this.active_modules.split(",")
    this.$store.dispatch('setEnvVariable', ["active_modules", active_modules_list])

    if (this.$store.getters.getEnvVariable("module_server") == "DYNAMIC") {
      this.module_server = window.location.host
      this.module_server_port = ""
      this.module_server_protocol = window.location.protocol
      this.module_server_protocol = this.module_server_protocol.replace(":", "")
      this.$store.dispatch('setEnvVariable', ["module_server", this.module_server])
      this.$store.dispatch('setEnvVariable', ["module_server_port", this.module_server_port])
      this.$store.dispatch('setEnvVariable', ["module_server_protocol", this.module_server_protocol])
    }

    // init full request paths
    this.$store.dispatch('setPathVariable', ["methods_get_ids", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_ids])
    this.$store.dispatch('setPathVariable', ["methods_get_mtb_conferences", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_mtb_conferences])
    this.$store.dispatch('setPathVariable', ["methods_get_mtb_data", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_mtb_data])
    this.$store.dispatch('setPathVariable', ["methods_get_id_feature_data", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_id_feature_data])
    this.$store.dispatch('setPathVariable', ["methods_get_id_variant_data", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_id_variant_data])
    this.$store.dispatch('setPathVariable', ["methods_upload_vcf", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_upload_vcf])
    this.$store.dispatch('setPathVariable', ["methods_get_variant_search", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_variant_search])
    this.$store.dispatch('setPathVariable', ["methods_analyze_variants", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_analyze_variants])
    this.$store.dispatch('setPathVariable', ["methods_get_annotated_modules", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_annotated_modules])
    this.$store.dispatch('setPathVariable', ["methods_get_sample_vcf_data", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_sample_vcf_data])
    this.$store.dispatch('setPathVariable', ["methods_generate_new_id", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_generate_new_id])
    this.$store.dispatch('setPathVariable', ["methods_generate_plot", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_generate_plot])
    this.$store.dispatch('setPathVariable', ["methods_download_results", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_download_results])
    this.$store.dispatch('setPathVariable', ["methods_get_sample_file", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port")
      + this.methods_get_sample_file])
    this.$store.dispatch('setPathVariable', ["methods_get_am_region_scores", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_am_port")
      + this.methods_get_am_region_scores])
    this.$store.dispatch('setPathVariable', ["methods_get_os_swagger_endpoint", this.$store.getters.getEnvVariable("module_server_protocol")
      + "://" + this.$store.getters.getEnvVariable("module_server") + this.$store.getters.getEnvVariable("module_server_port") + this.methods_get_os_swagger_endpoint])


    // Read data descriptions (metadata) from file and save them in the store
    dd.readSourceFile();
  },
  mounted: function () {
    //this.onResize()
    if (!localStorage.getItem("onkopus_consent")) this.popup_open = true;

    //window.addEventListener('resize', this.onResize, { passive: true })
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      this.tt_open = false;
    },
  },
}

</script>

<style>
.a-light {
  color: #FFFFFF;
}

html, body {
  scrollbar-width: auto; /* For Firefox */
  scrollbar-color: #888 #f1f1f1; /* Thumb and track color for Firefox */
}

#app {
  /*font-weight:400;*/
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  scrollbar-width: auto;
}

.grid-stack {
  /*background: #FAFAD2;*/
  background: #fff;
}

.grid-stack-item-content {
  /*background-color: #18BC9C;*/
  border: 1px solid black;
}

.plain_title {
  color: #000000;
  text-decoration: None;
}

.title-light {
  color: #FFFFFF;
  text-decoration: none;
}

.button-light {
  background-color: #FFFFFF;
  text-decoration: none;
}

.top-search-bar {
  max-width: 300px;
  color: #FFFFFF;
}

.menu-btn:hover {
  background-color: #d3d3d3;
}

.page {
  position: absolute;
  top: 20px;
}

.fade-custom-enter-active,
.fade-custom-leave-active {
  transition: opacity 0.5s;
}

.fade-custom-enter,
.fade-custom-leave-to {
  opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.carousel-sheet-container {
  font-size: 1.25rem;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Base CSS variables */

:root {
  --white: #fff;
  --darkest: #000;
  --dark-blue: #004476;
  --default-blue: #2196f3;
  --light-blue: #c3e4ff;
  --light-grey: #e4e4e4;
  --lighter-grey: #f4f4f4;
  --dark-grey: #c3c3c3;
  --pathogenic: #ec8479;


  --default-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  --stronger-shadow: rgba(0, 0, 0, 0.3) 1.95px 1.95px 2.6px 0.5px;
  --default-font: var(--pure-material-font, "Roboto", "Segoe UI", BlinkMacSystemFont, system-ui, -apple-system);


  --font-200: 0.75rem;
  --font-300: 0.85rem;
  --font-400: 0.875rem;
  --font-500: 0.9125rem;
  --font-600: 1rem;
  --font-700: 1.125rem;
  --font-800: 1.25rem;
  --font-1000: 1.5rem;

  /*--default-gradient: linear-gradient(to right, var(--dark-blue) 0%, var(--default-blue) 100%);*/
  --default-gradient: linear-gradient(to right, #038aa7 0%, #b0e0ee 100%);
  --inverse-gradient: linear-gradient(to left, var(--dark-blue) 0%, var(--default-blue) 100%);
  --dual-gradient: linear-gradient(to left, var(--dark-blue) 0%, var(--default-blue) 50%, var(--dark-blue) 100%);
}

/* Helper classes */

.default-shadow {
  box-shadow: var(--default-shadow);
}

.default-font {
  font-family: var(--default-font);
}

.bg-light-grey {
  background-color: var(--light-grey);
}

.vuetify-font {
  font-family: var(--text-button);
  letter-spacing: .0892857143em;
  font-weight: 500;
  font-size: var(--font-400);
}

/* Resets */

router-link {
  text-decoration: none;
}

html {
  border-top: none;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.75s ease-out;
}

.slide-enter-to {
  position: absolute;
  right: 0;
}

.slide-enter-from {
  position: absolute;
  right: -100%;
}

.slide-leave-to {
  position: absolute;
  left: -100%;
}

.slide-leave-from {
  position: absolute;
  left: 0;
}

.wrapper-content {
  width: 100%;
  min-height: 80vh;
}


.leaving,
.entering {
  transition: opacity 300ms ease-in-out;
}

.to,
.from {
  opacity: 0;
}

</style>
